/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { useEffect, useState } from "react";

type ScreenOrientation = "portrait" | "landscape";

const mediaQuery =
  typeof window !== "undefined"
    ? window.matchMedia("screen and (orientation: portrait)")
    : undefined;

export const useScreenOrientation = (): ScreenOrientation => {
  const [orientation, setOrientation] = useState<ScreenOrientation>(
    mediaQuery?.matches ? "portrait" : "landscape",
  );

  useEffect(() => {
    if (!mediaQuery) return;

    const callback = (event: MediaQueryListEvent) => {
      setOrientation(event.matches ? "portrait" : "landscape");
    };

    mediaQuery.addEventListener("change", callback);

    return () => {
      mediaQuery.removeEventListener("change", callback);
    };
  }, []);

  return orientation;
};
